import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#f5f5f5' }}>
      {/* Main Content */}
      <main style={{ 
        flex: 1,
        padding: '1.5rem',
        paddingBottom: user ? 'calc(1.5rem + 80px)' : '1.5rem',
        maxWidth: '100%',
        minHeight: '100vh'
      }}>
        <div style={{
          maxWidth: '1280px',
          margin: '0 auto',
          width: '100%'
        }}>
          {children}
        </div>
      </main>

      {/* Bottom Navigation - All Screens */}
      {user && (
        <nav style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: 'white',
          boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.1)',
          zIndex: 1000,
          borderTop: '1px solid #e5e7eb',
          display: 'flex',
          justifyContent: 'space-around',
          padding: '0.75rem 0',
          paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))'
        }}>
          <NavButton to="/dashboard" isActive={isActive('/dashboard')} icon="🏠" label="Inicio" />
          <NavButton to="/exercises" isActive={isActive('/exercises')} icon="💪" label="Ejercicios" />
          <NavButton to="/routines" isActive={isActive('/routines')} icon="📋" label="Rutinas" />
          <NavButton to="/anthropometric" isActive={isActive('/anthropometric') || location.pathname.startsWith('/anthropometric')} icon="📏" label="Medidas" />
          <NavButton to="/profile" isActive={isActive('/profile')} icon="👤" label="Perfil" />
        </nav>
      )}
    </div>
  );
}

function NavButton({ to, isActive, icon, label }) {
  return (
    <Link
      to={to}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.25rem',
        textDecoration: 'none',
        padding: '0.5rem 1rem',
        borderRadius: '12px',
        transition: 'all 0.2s ease',
        background: isActive ? '#eff6ff' : 'transparent',
        minWidth: '70px'
      }}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.transform = 'scale(1.05)';
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.transform = 'scale(1)';
        }
      }}
    >
      <span style={{ 
        fontSize: '1.5rem',
        filter: isActive ? 'none' : 'grayscale(30%)',
        transition: 'all 0.2s ease'
      }}>
        {icon}
      </span>
      <span style={{ 
        fontSize: '0.625rem', 
        fontWeight: 600, 
        color: isActive ? '#3b82f6' : '#6b7280',
        transition: 'all 0.2s ease'
      }}>
        {label}
      </span>
    </Link>
  );
}

export default Layout;
